import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'atlassian-intelligence.common.ai-button-popup.heading',
		defaultMessage: 'Speed up your search',
		description: 'Heading displayed in the AI Popup',
	},
	adminDescription: {
		id: 'atlassian-intelligence.common.ai-button-popup.admin-description',
		defaultMessage:
			'<p>With <learn_more_link>Atlassian Intelligence</learn_more_link> (AI), your team can find their issues faster with a simple prompt.</p><p>Activate Atlassian Intelligence for your users from Atlassian Administration.</p>',
		description: 'Message body text shown in the AI popup component for Org admin user',
	},
	adminDescriptionRovo: {
		id: 'atlassian-intelligence.common.ai-button-popup.admin-description-rovo',
		defaultMessage:
			'<p>With <learn_more_link>Rovo</learn_more_link>, your team can find their issues faster with a simple prompt.</p><p>Activate Rovo for your users from Atlassian Administration.</p>',
		description:
			'Message body text shown in the AI popup component for Org admin user (Rovo variant)',
	},
	userDescription: {
		id: 'atlassian-intelligence.common.ai-button-popup.user-description',
		defaultMessage:
			"<p>With <learn_more_link>Atlassian Intelligence</learn_more_link> (AI), find your issues faster by typing a simple prompt.</p><p>Contact your organization admin if you're interested in trying Atlassian Intelligence.</p>",
		description: 'Message body text shown in the AI popup component for end user',
	},
	userDescriptionRovo: {
		id: 'atlassian-intelligence.common.ai-button-popup.user-description-rovo',
		defaultMessage:
			"<p>With <learn_more_link>Rovo</learn_more_link>, find your issues faster by typing a simple prompt.</p><p>Contact your organization admin if you're interested in trying Rovo.</p>",
		description: 'Message body text shown in the AI popup component for end user (Rovo variant)',
	},
	learnMore: {
		id: 'atlassian-intelligence.common.ai-button-popup.learn-more',
		defaultMessage: 'Learn more about Atlassian Intelligence',
		description: 'Link for getting to know more about Atlassian Intelligence',
	},
	learnMoreRovo: {
		id: 'atlassian-intelligence.common.ai-button-popup.learn-more-rovo',
		defaultMessage: 'Learn more about Rovo',
		description: 'Link for getting to know more about Rovo',
	},
	dismissButton: {
		id: 'atlassian-intelligence.common.ai-button-popup.dismiss-button',
		defaultMessage: 'Maybe later',
		description: 'Button label to dismiss the popup',
	},
	adminButton: {
		id: 'atlassian-intelligence.common.ai-button-popup.admin-button',
		defaultMessage: 'Get Started',
		description: 'Button label used for redirecting Org admin to turn on Rovo',
	},
	userButton: {
		id: 'atlassian-intelligence.common.ai-button-popup.user-button',
		defaultMessage: 'Contact your Admin',
		description: 'Button label used for end user to request Org admin to turn on Rovo',
	},
	aiOptInAltMessage: {
		id: 'atlassian-intelligence.common.ai-button-popup.banner-alt',
		defaultMessage: 'Decorative pop up banner',
		description:
			'This is the alt text of a banner image. The image is inside a popup which points users to enable AI for their org. The image is for decorative purpose only.',
	},
	adminDescriptionIssueTermRefresh: {
		id: 'atlassian-intelligence.common.ai-button-popup.admin-description-issue-term-refresh',
		defaultMessage:
			'<p>With <learn_more_link>Atlassian Intelligence</learn_more_link> (AI), your team can find their work faster with a simple prompt.</p><p>Activate Atlassian Intelligence for your users from Atlassian Administration.</p>',
		description: 'Message body text shown in the AI popup component for Org admin user',
	},
	adminDescriptionIssueTermRefreshRovo: {
		id: 'atlassian-intelligence.common.ai-button-popup.admin-description-issue-term-refresh-rovo',
		defaultMessage:
			'<p>With <learn_more_link>Rovo</learn_more_link>, your team can find their work faster with a simple prompt.</p><p>Activate Rovo for your users from Atlassian Administration.</p>',
		description:
			'Message body text shown in the AI popup component for Org admin user (Rovo variant)',
	},
	userDescriptionIssueTermRefresh: {
		id: 'atlassian-intelligence.common.ai-button-popup.user-description-issue-term-refresh',
		defaultMessage:
			"<p>With <learn_more_link>Atlassian Intelligence</learn_more_link> (AI), find your work faster by typing a simple prompt.</p><p>Contact your organization admin if you're interested in trying Atlassian Intelligence.</p>",
		description: 'Message body text shown in the AI popup component for end user',
	},
	userDescriptionIssueTermRefreshRovo: {
		id: 'atlassian-intelligence.common.ai-button-popup.user-description-issue-term-refresh-rovo',
		defaultMessage:
			"<p>With <learn_more_link>Rovo</learn_more_link>, find your work faster by typing a simple prompt.</p><p>Contact your organization admin if you're interested in trying Rovo.</p>",
		description: 'Message body text shown in the AI popup component for end user (Rovo variant)',
	},
});
